module.exports = __webpack_public_path__ + "img/img52.84b1ca53.jpg";